import { h } from 'preact';
import cx from 'classnames';
import '../../bootstrap/bootstrap-grid.css';
import style from './style';

export const Container = (props) => {
	let { children, baseClass } = props;

	// Bail if we have nothing valid to display
	if (!Array.isArray(children) || !children.length) {
		return null;
	}

	return (
		<div class={cx(baseClass || 'container', props.class, style.container, props.expandColumn && style.expandColumn)}>
			{children}
		</div>
	);
};

export default Container;
